/* ADD Knowledge categories */
export const ADD_KNOWLEDGE_CATEGORY = "ADD_KNOWLEDGE_CATEGORY"
export const ADD_KNOWLEDGE_CATEGORY_SUCCESS = "ADD_KNOWLEDGE_CATEGORY_SUCCESS"
export const ADD_KNOWLEDGE_CATEGORY_CLEAN = "ADD_KNOWLEDGE_CATEGORY_CLEAN"
export const API_ERROR = "API_ERROR"
